import { LocationPage } from "./LocationPage";

export default LocationPage;
